export const worksData = [
  {
    id: 1,
    title: '地元サッカークラブ卒団記念マグカップ',
    category: '記念品',
    description: 'チームロゴと選手名を一つ一つ丁寧に印刷。子どもたちの思い出に残る特別な記念品となりました。',
    image: 'https://public.readdy.ai/ai/img_res/ca6f140a12f71603ac098508ab02ecc6.jpg',
  },
  {
    id: 2,
    title: '企業ノベルティステンレスボトル',
    category: '販促物',
    description: '企業ロゴをレーザー印刷で高級感のある仕上がりに。長く使える実用的なノベルティとして好評です。',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20sleek%20stainless%20steel%20water%20bottles%20with%20elegant%20laser-engraved%20corporate%20logos%20displayed%20on%20a%20modern%20minimalist%20surface%20with%20professional%20studio%20lighting%20and%20a%20clean%20simple%20background%20highlighting%20the%20premium%20quality%20finish&width=800&height=600&seq=work002&orientation=landscape',
  },
  {
    id: 3,
    title: 'カフェオリジナルマグカップ',
    category: '商品',
    description: 'お店のロゴとオリジナルデザインを印刷。お客様へのギフトとしても人気の商品になりました。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20coffee%20mugs%20with%20artistic%20cafe%20logo%20designs%20in%20warm%20colors%20displayed%20on%20a%20wooden%20table%20in%20a%20cozy%20cafe%20atmosphere%20with%20soft%20natural%20lighting%20and%20a%20clean%20blurred%20background&width=800&height=600&seq=work003&orientation=landscape',
  },
  {
    id: 4,
    title: 'イベント用オリジナルTシャツ',
    category: '記念品',
    description: '地域イベントのスタッフTシャツ。シルク印刷で鮮やかな発色と耐久性を実現しました。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20event%20staff%20t-shirts%20with%20vibrant%20silk%20screen%20printed%20designs%20laid%20flat%20on%20a%20clean%20white%20surface%20with%20professional%20studio%20lighting%20and%20a%20minimalist%20plain%20background%20showing%20high%20quality%20printing&width=800&height=600&seq=work004&orientation=landscape',
  },
  {
    id: 5,
    title: '学校創立記念タンブラー',
    category: '記念品',
    description: '学校の校章と創立年を印刷。卒業生や在校生に配布される特別な記念品です。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20commemorative%20tumblers%20with%20school%20emblems%20and%20anniversary%20year%20printed%20in%20gold%20arranged%20on%20a%20sophisticated%20display%20with%20soft%20lighting%20and%20a%20clean%20simple%20background%20showcasing%20premium%20quality&width=800&height=600&seq=work005&orientation=landscape',
  },
  {
    id: 6,
    title: '企業周年記念品セット',
    category: '記念品',
    description: 'マグカップ、ボトル、タオルなど複数アイテムに統一デザインで印刷。記念品として配布されました。',
    image: 'https://readdy.ai/api/search-image?query=A%20premium%20gift%20set%20including%20mugs%20bottles%20and%20towels%20with%20matching%20corporate%20anniversary%20designs%20arranged%20elegantly%20on%20a%20clean%20surface%20with%20professional%20studio%20lighting%20and%20a%20minimalist%20plain%20background&width=800&height=600&seq=work006&orientation=landscape',
  },
  {
    id: 7,
    title: 'スポーツチームユニフォーム',
    category: '販促物',
    description: 'チーム名、背番号、スポンサーロゴを高品質に印刷。選手たちのモチベーション向上に貢献しました。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20team%20uniforms%20with%20team%20names%20numbers%20and%20sponsor%20logos%20printed%20in%20vibrant%20colors%20displayed%20on%20mannequins%20with%20studio%20lighting%20and%20a%20clean%20simple%20background%20showing%20excellent%20print%20quality&width=800&height=600&seq=work007&orientation=landscape',
  },
  {
    id: 8,
    title: '飲食店オリジナルグッズ',
    category: '商品',
    description: 'マグカップ、コースター、エコバッグなど店舗オリジナルグッズを制作。お客様に大変喜ばれています。',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20restaurant%20branded%20merchandise%20including%20mugs%20coasters%20and%20eco%20bags%20with%20matching%20designs%20arranged%20attractively%20on%20a%20wooden%20surface%20with%20warm%20lighting%20and%20a%20clean%20blurred%20background&width=800&height=600&seq=work008&orientation=landscape',
  },
  {
    id: 9,
    title: '結婚式プチギフトマグカップ',
    category: '記念品',
    description: '新郎新婦の名前と日付を印刷。ゲストへの感謝の気持ちを込めた特別なギフトです。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20white%20ceramic%20mugs%20with%20romantic%20wedding%20designs%20and%20couple%20names%20printed%20in%20soft%20pastel%20colors%20arranged%20beautifully%20with%20flowers%20on%20a%20clean%20surface%20with%20soft%20lighting%20and%20a%20minimalist%20background&width=800&height=600&seq=work009&orientation=landscape',
  },
];
